import { useEffect, useRef } from 'react';
var useUpdateEffect = function (callback, dependencies) {
    var first = useRef(true);
    useEffect(function () {
        if (first.current) {
            first.current = false;
            return;
        }
        return callback();
    }, dependencies);
};
export { useUpdateEffect };
//# sourceMappingURL=useUpdateEffect.js.map